import { createRoutine } from "redux-saga-routines";

const Logout = createRoutine("LOGOUT");
const GetMe = createRoutine("GET_ME");
const SetToken = createRoutine("SET_TOKEN");
const SET_ACTIVE_ORGANIZATION = createRoutine("SET_ACTIVE_ORGANIZATION");
const SetMaintenanceMode = createRoutine("SET_MAINTENANCE_MODE");

export default {
  Logout,
  GetMe,
  SetToken,
  SET_ACTIVE_ORGANIZATION,
  SetMaintenanceMode,
};
